var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_39",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.032 10.877L18.661 5.622C19.294 5.393 19.846 5.776 19.641 6.733L17.321 17.664C17.149 18.439 16.688 18.628 16.044 18.264L12.51 15.664L10.81 17.306C10.7261 17.4151 10.6181 17.5034 10.4944 17.5637C10.3707 17.6241 10.2346 17.655 10.097 17.654L10.348 14.054L16.894 8.133C17.179 7.882 16.83 7.741 16.455 7.99L8.361 13.09L4.871 11.999C4.114 11.759 4.097 11.242 5.031 10.876L5.032 10.877Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.b21bb36187cb85edaea6cf3026e49dd4.svg";
export { ForwardRef as ReactComponent };